import React, {Component} from "react";
import {compose} from "redux";
import {connect} from "react-redux";
import {deleteCompanyLogo, getCompanyLogo, uploadCompanyLogo} from "../../actions/companies";
import * as PropTypes from "prop-types";
import NotFound from "../cProject-not-found.png";
import {withTransparentLoading} from "./deferLoaderHoc";
import {Button, Card, Tooltip} from "antd";

class CompanyLogo extends Component {
  handleUpload(files) {
    const { onUpload } = this.props;
    let queuedFiles = Array.from(files);
    if (!queuedFiles.length) return;
    if (onUpload) onUpload(queuedFiles[0]);
  }

  handleUploadClick = () => {
    this.uploadRef.current.click();
  };

  handleDelete = () => {
    const { onDelete } = this.props;
    if (onDelete) onDelete();
  };

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) onMount();
  }

  constructor(props) {
    super(props);
    this.uploadRef = React.createRef();
  }

  render() {
    const { logo: { url = null } = {}, profile = {}, company: { resource: company = {} } = {} } = this.props;
    if (!company) return;
    return <Card title={<h1>Company Logo</h1>} className={'bid-dashboard-column-card'} extra={
      (profile.companyid === company.id && profile.companyadmin) && <div className='bid-dashboard-controls'>
        {url && <Button icon='delete' onClick={this.handleDelete}>
          <span className='hidden inline visible-xxl'>Delete</span>
        </Button>}
        <Tooltip title={'Please note that company logos may take up to 24 hours to update in our system when replaced.'}>
          <Button icon='upload' onClick={this.handleUploadClick}>
            <span className='hidden inline visible-xxl'>Upload</span>
            <input style={{ display: 'none' }} type='file' ref={this.uploadRef} accept='image/*'
                   onChange={e => this.handleUpload(e.target.files)}/>
          </Button>
        </Tooltip>
      </div>
    }>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div className='bid-dashboard-photo'>
          <div style={{backgroundImage: `url('${url ? url : NotFound}')`}}/>
        </div>
      </div>
    </Card>;
  }
}

CompanyLogo.propTypes = { id: PropTypes.any };

export default compose(
  connect(
    (state, props) => ({
      logo: state.logos.data[props.id],
      profile: state.profile,
      company: state.companies.data[props.id],
    }),
    (dispatch, props) => ({
      loader: () => dispatch(getCompanyLogo({ id: props.id })),
      onUpload: file => dispatch(uploadCompanyLogo({ id: props.id, file })),
      onDelete: () => dispatch(deleteCompanyLogo({ id: props.id })),
    }),
  ),
  withTransparentLoading,
)(CompanyLogo)



// WEBPACK FOOTER //
// ./src/components/Boilerplate/CompanyLogo.js